// Informant Example
// ***
// This shows the simplest usage of Informant

import { Form, FormProvider, SuperSchema } from '@updater/ui-informant';

export const schema: SuperSchema = {
  type: 'object',
  properties: {
    email: {
      title: 'email',
      type: 'string',
    },
  },
};

export const MyForm = () => {
  const handleSubmit = (values: unknown) => {
    alert(`Submitted values: ${JSON.stringify(values, null, 2)}`);
  };

  return (
    <>
      <FormProvider schema={schema} onSubmit={handleSubmit}>
        <Form />
      </FormProvider>
    </>
  );
};
